import React from 'react';
import { Modal, Button, Alert } from 'antd';
import { t } from '../../../../i18n';
import step1Img from './images/address-guide-step1.png';
import step2Img from './images/address-guide-step2.png';

interface Props {
    open: boolean;
    onClose: () => void;
    zIndex?: number;
}

const AddressGuideModal: React.FC<Props> = ({ open, onClose, zIndex }) => {
    return (
        <Modal
            title={t('delivery.parcels.guide.title')}
            open={open}
            onCancel={onClose}
            width={720}
            zIndex={zIndex}
            maskClosable
            footer={[
                <Button key="gotIt" type="primary" onClick={onClose}>
                    {t('delivery.parcels.guide.gotIt')}
                </Button>,
            ]}
        >
            <Alert
                type="warning"
                showIcon
                message={t('delivery.parcels.guide.warning')}
                className="mb-4"
            />
            <div className="mb-4">
                <div className="font-medium mb-2">{t('delivery.parcels.guide.step1Title')}</div>
                <div className="text-gray-600 mb-2">{t('delivery.parcels.guide.step1Desc')}</div>
                <img src={step1Img} alt="step1" className="w-full border" />
            </div>
            <div>
                <div className="font-medium mb-2">{t('delivery.parcels.guide.step2Title')}</div>
                <img src={step2Img} alt="step2" className="w-full border" />
            </div>
        </Modal>
    );
};

export default AddressGuideModal;
